import styled from '@emotion/styled'
import { Header } from 'components/patterns/Typography'
import { Badge } from 'components/patterns'

export const ReviewHeader = styled.div`
  margin-bottom: 24px;
  display: flex;
  flex-direction: row;
  align-items: center;
  & > h3 {
    color: var(--Black-Black-Secondary, rgba(7, 7, 15, 0.7));
    font-family: Arial;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 22px;
  }
  & > h4 {
    margin-left: 8px;
    font-weight: normal;
    font-size: 14px;
  }
`

export const ConflictCell = styled.span`
  ${Header} {
    display: inline;
    margin-right: 8px;
  }
`

export const StyledBadge = styled(Badge)``
